import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import {
    FaClipboardCheck, FaMapMarkerAlt, FaEye,
    FaUserShield, FaCalendarAlt, FaStore, FaImages, FaInfoCircle, FaChevronLeft
} from "react-icons/fa";

export default function VisitsPage() {
    const location = useLocation();
    const { backEnd_request } = BackMethods();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [visits, setVisits] = useState([]);

    const query = new URLSearchParams(location.search);

    const truncateWords = (text, limit) => {
        if (!text) return "---";
        const words = text.split(" ");
        return words.length > limit ? words.slice(0, limit).join(" ") + "..." : text;
    };

    useEffect(() => {
        const fetchVisits = async () => {
            setLoading(true);
            try {
                let data = [];
                const establishmentId = query.get("establishment");
                const type = query.get("type");
                const inspector = query.get("inspector");
                const staffName = query.get("staffName");

                if (establishmentId) {
                    data = await backEnd_request.get(`/InspectionVisits/by-establishment/${establishmentId}`).then(r => r.data);
                } else if (type) {
                    data = await backEnd_request.get(`/InspectionVisits/by-type?type=${type}`).then(r => r.data);
                } else if (inspector || staffName) {
                    data = await backEnd_request.get(`/InspectionVisits/by-inspector?inspectorName=${inspector || staffName}`).then(r => r.data);
                } else {
                    data = await backEnd_request.get(`/InspectionVisits`).then(r => r.data);
                }
                setVisits(Array.isArray(data) ? data : [data]);
            } catch (err) {
                console.error("Error:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchVisits();
    }, [location.search]);

    return (
        <div className="bg-light min-vh-100 py-3 py-md-4" dir="rtl">
            <div className="container-fluid px-3 px-md-4">

                {/* Header المتجاوب */}
                <div className="card border-0 shadow-sm rounded-4 mb-4 overflow-hidden border-start border-primary border-5">
                    <div className="card-body p-3 p-md-4 bg-white d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3">
                        <div className="text-center text-sm-end">
                            <h4 className="fw-bold text-dark m-0 d-flex align-items-center justify-content-center justify-content-sm-start">
                                <FaClipboardCheck className="ms-2 text-primary" />
                                {query.get("staffName") ? `زيارات: ${query.get("staffName")}` : "سجل الزيارات"}
                            </h4>
                            <span className="badge bg-primary-subtle text-primary rounded-pill mt-2">
                                إجمالي الزيارات: {visits.length}
                            </span>
                        </div>
                        <button onClick={() => navigate(-1)} className="btn btn-dark rounded-pill px-4 btn-sm shadow-sm">
                            <FaChevronLeft className="ms-1" /> رجوع
                        </button>
                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>
                ) : (
                    <>
                        {/* عرض الموبايل (Cards) - يظهر فقط في الشاشات الصغيرة */}
                        <div className="d-block d-lg-none">
                            {visits.map((v) => (
                                <div key={v.visitUid} className="card border-0 shadow-sm rounded-4 mb-3 p-3 position-relative" onClick={() => navigate(`/admin/visit-details/${v.visitUid}`)}>
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="bg-soft-primary p-3 rounded-3 ms-3">
                                            <FaStore className="text-primary fs-4" />
                                        </div>
                                        <div className="flex-grow-1">
                                            <div className="fw-bold text-dark">{v.establishment?.name || "غير معروف"}</div>
                                            <div className="x-small text-muted">{v.visitType} | ID: {v.visitId}</div>
                                        </div>
                                        <div className="action-btn view shadow-sm">
                                            <FaEye />
                                        </div>
                                    </div>

                                    <div className="row g-2 border-top pt-3">
                                        <div className="col-6">
                                            <small className="text-muted d-block">الموظف</small>
                                            <span className="small fw-bold"><FaUserShield className="ms-1 x-small" /> {v.inspector1Name || "---"}</span>
                                        </div>
                                        <div className="col-6 text-start">
                                            <small className="text-muted d-block">التاريخ</small>
                                            <span className="small fw-bold"><FaCalendarAlt className="ms-1 x-small text-info" /> {v.visitDate?.split("T")[0]}</span>
                                        </div>
                                        <div className="col-12 mt-2 bg-light p-2 rounded-3">
                                            <small className="text-muted d-block mb-1">تقرير مختصر:</small>
                                            <p className="x-small m-0 italic text-secondary">{truncateWords(v.visitReport, 15)}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* عرض الشاشات الكبيرة (Table) - يختفي في الجوال */}
                        <div className="d-none d-lg-block table-responsive custom-table-container">
                            <table className="table table-hover align-middle main-modern-table">
                                <thead>
                                    <tr>
                                        <th>المنشأة</th>
                                        <th>نوع الزيارة</th>
                                        <th>الموظف</th>
                                        <th>تقرير الزيارة</th>
                                        <th>الموقع</th>
                                        <th>التاريخ</th>
                                        <th className="text-center">التفاصيل</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {visits.map((v) => (
                                        <tr key={v.visitUid} className="table-row-item">
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div className="bg-soft-primary p-2 rounded-2 ms-2">
                                                        <FaStore className="text-primary" />
                                                    </div>
                                                    <div>
                                                        <div className="fw-bold text-dark small text-truncate" style={{ maxWidth: '150px' }}>{v.establishment?.name || "غير معروف"}</div>
                                                        <div className="x-small text-muted">ID: {v.visitId}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span className={`badge ${v.visitType === 'تموينية' ? 'bg-info' : 'bg-secondary'} fw-normal rounded-pill`}>
                                                    {v.visitType}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="small fw-bold   " style={{ maxWidth: '180px' }}><FaUserShield className="ms-1 text-muted" /> {v.inspector1Name || "---"}</div>
                                            </td>
                                            <td style={{ maxWidth: '200px' }}>
                                                <div className="x-small text-dark italic">{truncateWords(v.visitReport, 12)}</div>
                                                {v.photos?.length > 0 && <div className="mt-1 x-small text-primary fw-bold"><FaImages className="ms-1" /> {v.photos.length} صور</div>}
                                            </td>
                                            <td>
                                                <div className="small fw-bold">{v.governorate || "---"}</div>
                                                <div className="x-small text-muted text-truncate" style={{ maxWidth: '100px' }}><FaMapMarkerAlt className="ms-1" />{v.district || "---"}</div>
                                            </td>
                                            <td>
                                                <div className="small fw-bold text-dark">{v.visitDate?.split("T")[0]}</div>
                                                <div className="x-small text-muted">{v.visitTime?.slice(0, 5)}</div>
                                            </td>
                                            <td className="text-center">
                                                <button className="action-btn view mx-auto" onClick={() => navigate(`/admin/visit-details/${v.visitUid}`)}>
                                                    <FaEye />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {visits.length === 0 && (
                            <div className="text-center py-5 bg-white rounded-4 shadow-sm mt-3 text-muted">
                                لا توجد زيارات مسجلة حالياً
                            </div>
                        )}
                    </>
                )}
            </div>

            <style>{`
                .x-small { font-size: 0.72rem; }
                .bg-soft-primary { background-color: #eef5ff; }
                .main-modern-table { border-collapse: separate; border-spacing: 0 10px; }
                .main-modern-table thead th { border: none; color: #8898aa; font-size: 0.75rem; text-transform: uppercase; padding: 0 15px; }
                
                .table-row-item { background-color: #fff; transition: all 0.2s; cursor: pointer; }
                .table-row-item td { padding: 15px; border: none; }
                .table-row-item td:first-child { border-top-right-radius: 15px; border-bottom-right-radius: 15px; border-right: 4px solid #0d6efd; }
                .table-row-item td:last-child { border-top-left-radius: 15px; border-bottom-left-radius: 15px; }
                .table-row-item:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(0,0,0,0.08); background-color: #fcfdff !important; }

                .action-btn.view { 
                    width: 36px; height: 36px; border-radius: 10px; border: none;
                    background: #212529; color: #fff; display: flex; align-items: center; justify-content: center;
                    transition: 0.3s;
                }
                .action-btn.view:hover { background: #0d6efd; transform: scale(1.1); }
                
                .italic { font-style: italic; }

                @media (max-width: 768px) {
                    .container-fluid { padding-left: 10px; padding-right: 10px; }
                    h4 { font-size: 1.1rem; }
                }
            `}</style>
        </div>
    );
}